import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addTaskStatus, getTaskStatus, updateTaskStatus, deleteTaskStatus} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class TaskStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            taskstatus: ''
        }
        this.handleTaskStatusSubmit = this.handleTaskStatusSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (taskstatus) => {
        this.setState({ taskstatus: taskstatus });
        this.setState({ deleteModal: true });
    };

    handleDeleteTaskStatus = () => {
        const { onDeleteTaskStatus } = this.props;
        const { taskstatus } = this.state;

        if (taskstatus.id !== taskstatus) {
            onDeleteTaskStatus(taskstatus);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleTaskStatusSubmit(value) {
        this.props.addTaskStatus(value, this.props.history);
    }

    componentDidMount() {
        const { onGetTaskStatus } = this.props;
        onGetTaskStatus(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { taskstatuses } = this.props;
        if (!isEmpty(taskstatuses) && size(prevProps.taskstatuses) !== size(taskstatuses)) {
            this.setState({ taskstatuses: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ taskstatus: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const taskstatus = arg;
        this.setState({
            taskstatus: {
                id: taskstatus.id,
                taskStatusId: taskstatus.taskStatusId,
                taskStatusCode: taskstatus.taskStatusCode,
                taskStatusTitle:taskstatus.taskStatusTitle,
                agentId: taskstatus.agentId,
                isActive: taskstatus.isActive
            },
            isEdit: true,
        });
        this.toggle();
        //
    };
    
    render() {
        const { taskstatuses, onUpdateTaskStatus } = this.props;
        const { isEdit, deleteModal } = this.state;
        const taskstatus = this.state.taskstatus;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteTaskStatus}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Task Status")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        taskStatusCode: (this.state && this.state.taskStatusCode) || "",
                                        taskStatusTitle: (this.state && this.state.taskStatusTitle) || "",
                                    

                                    }}
                                    validationSchema={Yup.object().shape({
                                        //taskStatusCode:Yup.string().required("This is required"),
                                        taskStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleTaskStatusSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Task Status</CardTitle>
                                                    <Row>

                                                    {/* <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskStatusCode">
                                                                    {this.props.t("Code")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskStatusCode"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskStatusCode && touched.taskStatusCode
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskStatusCode"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskStatusCode"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col> */}
                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskStatusTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskStatusTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskStatusTitle && touched.taskStatusTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskStatusTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskStatusTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    {/* <th>Code</th> */}
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(taskstatuses, (taskstatus, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        {/* <td>{taskstatus.taskStatusCode}</td> */}
                                                                        <td>{taskstatus.taskStatusTitle}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(taskstatus)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(taskstatus)} />
                                                                            
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: taskstatus.id,
                                        taskStatusId: taskstatus.taskStatusId,
                                        taskStatusCode: taskstatus.taskStatusCode,
                                        taskStatusTitle:taskstatus.taskStatusTitle,
                                        agentId: taskstatus.agentId,
                                        isActive: taskstatus.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        
                                        //taskStatusCode:Yup.string().required("This is required"),
                                        taskStatusTitle: Yup.string().required("This is required"),



                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                taskStatusId: values.taskStatusId,
                                                taskStatusCode: values.taskStatusCode,
                                                taskStatusTitle:values.taskStatusTitle,
                                                agentId: values.agentId,
                                                isActive: values.isActive
                                            };
                                            onUpdateTaskStatus(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                            {/* <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskStatusCode">
                                                                    {this.props.t("Code")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskStatusCode"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskStatusCode && touched.taskStatusCode
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskStatusCode"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskStatusCode"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col> */}
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskStatusTitle">
                                                                    {this.props.t("Title")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskStatusTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskStatusTitle && touched.taskStatusTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskStatusTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskStatusTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
TaskStatus.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addTaskStatus: PropTypes.func,
    onGetTaskStatus: PropTypes.func,
    taskstatuses: PropTypes.array,
    onDeleteTaskStatus: PropTypes.func,
    onUpdateTaskStatus: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        taskstatuses: AppoinmentObject.taskstatuses,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addTaskStatus: (data) => dispatch(addTaskStatus(data)),
    onGetTaskStatus: (agentId) => dispatch(getTaskStatus(agentId)),
    onDeleteTaskStatus: (id) => dispatch(deleteTaskStatus(id)),
    onUpdateTaskStatus: (data) => dispatch(updateTaskStatus(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TaskStatus))
